import type { FreelancerDocumentsInformationPageLocales } from '../types';

const freelancerDocumentsInformationPageLocales: FreelancerDocumentsInformationPageLocales =
  {
    helperMessage:
      'De volgende video vertelt je meer over de stappen die je moet doorlopen voor je mag starten met freelancen via Tadaah.',
    preferToreadInstructions: 'Liever de instructies lezen?',
    startDocs: 'Start documenten',
    thenClickHere: 'Klik dan hier',
    title: 'Documenten',
  };

export default freelancerDocumentsInformationPageLocales;
